// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad5d4d81","732":"0a197e3b","977":"2d62f251"}[chunkId] + ".chunk.js";
};